// src/appoinmentApp/utils/DebugSubscription.js
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const DebugSubscription = () => {
    const subscriptionStatus = useSelector(state => state.loginReducer?.subscriptionStatus);
    const loginDataFromStorage = localStorage.getItem('loginData');
    let storageStatus = null;
    
    try {
        if (loginDataFromStorage) {
            const parsed = JSON.parse(loginDataFromStorage);
            storageStatus = parsed.subscription_status;
        }
    } catch(e) {}
    
    useEffect(() => {
        console.log('🔍 [DEBUG] ========== SUBSCRIPTION STATUS CHECK ==========');
        console.log('🔍 [DEBUG] Redux subscriptionStatus:', subscriptionStatus);
        console.log('🔍 [DEBUG] localStorage subscription_status:', storageStatus);
        console.log('🔍 [DEBUG] Are they equal?', subscriptionStatus === storageStatus);
        console.log('🔍 [DEBUG] ================================================');
    }, [subscriptionStatus, storageStatus]);
    
    return null;
};

export default DebugSubscription;